export const isDateInPast = (dateString: string): boolean => {
  if (!dateString) {
    return false
  }

  const [year, month, day] = dateString.split('-').map(Number)

  if (!year || !month || !day) {
    return false
  }

  const targetDate = new Date(year, month - 1, day)

  const now = new Date()
  now.setHours(0, 0, 0, 0)
  return targetDate.getTime() < now.getTime()
}

export default isDateInPast
